export const FULL_NAME_REGEX = /\w\s\w/;
